import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import { API_PM } from '../../../../../commons/api';
import translation from '../../../../../commons/translation';
import localStorage from '../../../../../utils/localStorage';

import { SearchOutlined, EditOutlined } from '@ant-design/icons';
import { getPMList, deleteById } from '../../../Utils/FormCalls';
import { Input, Tooltip, Tag, Button } from 'antd';

const PMList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  // const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  let config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['Name', 'Description'],
    firstTitle: 'Name',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/PreventiveMaintenanceDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    _getDataSource();
  }, []);

  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile]);

  const editPM = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  // const _getUserList = async () => {
  //   const users = await getUsersList();
  //   setUserList(users);
  // };

  const _getDataSource = async () => {
    const data = await getPMList();
    setDataSource(data);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <SearchOutlined
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 90, marginRight: 8 }}
        />
        <Button onClick={() => handleReset(clearFilters, confirm)} style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const _deleteById = async (id) => {
    const siteId = localStorage.get('currentSite');
    const payload = {
      url: `${API_PM.DELETE}?Id=${id}&SiteId=${siteId}&Type=${'ESchedule'}`,
      method: 'POST'
    };
    await deleteById(payload);
    const data = await getPMList();
    setDataSource(data);
  };
  const { translationCache } = props;
  const columns = [
    {
      title: translation(props.translationCache, constant.name),
      dataIndex: 'Name',
      key: 'Name',
      filter: true,
      ...getColumnSearchProps('Name')
    },
    {
      title: translation(props.translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(props.translationCache, constant.site),
      dataIndex: 'SiteId',
      key: 'SiteId',
      filter: true
    },
    // {
    //   title: translation(props.translationCache, constant.site),
    //   dataIndex: 'SiteId',
    //   key: 'SiteId',
    //   filter: true
    // },
 
    {
      title: translation(props.translationCache, constant.status),
      dataIndex: 'Status',
      key: 'Status',
      render: (text) => (
        <Tag
          color={text === 'Active' ? '#87d068' : text === 'Inactive' ? '#ff4d4f' : 'gold'}
          key={text}>
          {text}
        </Tag>
      )
    },
    {
      title: translation(props.translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Tooltip placement="top" title={translation(props.translationCache, 'Edit')}>
            <Button disabled={record.Status === 'Inactive'} onClick={() => editPM(record)}>
              <EditOutlined />
            </Button>
          </Tooltip>
        </>
      )
    }
  ];
  config = {
    title: translation(translationCache, 'Preventive Maintenance'),
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',

    filterType: 'ByAttributeValue',
    attributeList: ['Name'],

    firstTitle: 'Name',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedDate',

    actions: ['edit'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/PreventiveMaintenanceDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        // userList={userList}
        config={config}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile
});

export default connect(mapStateToProps)(PMList);
